const textProps = {
  title: "Invoice",
  subtitle: "Everyone’s born confident, and everything’s taken away from",
  image: require("assets/img/pages/nathan-dumlao.jpg").default,
  skewColor: "blueGray",
};
export default textProps;
